const { IS_DEVELOPMENT_ENV } = require('./sitegen');

/** @type {string} */
const { ENABLE_DEV_TOOLS } = process.env;
/** @type {boolean} */
const ARE_DEV_TOOLS_ENABLED = !!ENABLE_DEV_TOOLS || IS_DEVELOPMENT_ENV;

module.exports.ARE_DEV_TOOLS_ENABLED = ARE_DEV_TOOLS_ENABLED;

// This object can be adjusted in the future for fine-grained control over development tools in different SiteGen environments
module.exports.DEV_TOOLS_CONFIG = {
    SOURCE_MAPS: ARE_DEV_TOOLS_ENABLED,
    REDUX_EXTENTION: ARE_DEV_TOOLS_ENABLED,
    REDUX_LOGGER: ARE_DEV_TOOLS_ENABLED
};

module.exports.ENABLE_DEV_TOOLS = ENABLE_DEV_TOOLS;
